import * as React from 'react';
import { IHeiPreferredStoreButtonViewProps } from './hei-preferred-store-button';
import classnames from 'classnames';

export default (props: IHeiPreferredStoreButtonViewProps) => {
    const {
        context: {
            actionContext: {
                requestContext: { cookies }
            }
        },
        config: { className },
        data: { storeSelectorStateManager },
        resources,
        store
    } = props;

    const [preferredStoreId, setPreferredStoreId] = React.useState(storeSelectorStateManager?.result?.preferredStore?.StoreId || '');

    const mgr = storeSelectorStateManager?.result;
    if (!mgr) {
        return null;
    }

    const isPreferredStore = preferredStoreId === store.OrgUnitNumber;

    return (
        <div className={classnames('hei-preferred-store-button', className)}>
            {isPreferredStore ? (
                <button
                    className='ms-store-select__location-line-item-preferred-store'
                    aria-label={resources.preferredStoreAriaLabel}
                    onClick={async () => {
                        await mgr.clearPreferredStore(cookies?.isConsentGiven());
                        setPreferredStoreId('');
                    }}
                >
                    {resources.preferredStoreText}
                </button>
            ) : (
                <button
                    className='ms-store-select__location-line-item-set-as-preferred-store'
                    aria-label={resources.setAsPreferredStoreTextAriaLabel}
                    onClick={async () => {
                        await mgr.setPreferredStoreLocation(
                            store.OrgUnitNumber,
                            store.OrgUnitName,
                            cookies?.isConsentGiven(),
                            store.Latitude,
                            store.Longitude
                        );

                        setPreferredStoreId(store.OrgUnitNumber || '');
                    }}
                >
                    {resources.setAsPreferredStoreText}
                </button>
            )}
        </div>
    );
};
